import { OnboardingRouteRedirect } from '../../components';

export default function Step9CalculatingRedirect() {
  return <OnboardingRouteRedirect to="/(onboarding)/step-8-calculating" />;
}
